import { render, staticRenderFns } from "./DocumentAttachModal.vue?vue&type=template&id=eabb1a1c&scoped=true&"
import script from "./DocumentAttachModal.vue?vue&type=script&lang=js&"
export * from "./DocumentAttachModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAttachModal.vue?vue&type=style&index=0&id=eabb1a1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eabb1a1c",
  null
  
)

export default component.exports